import React, {useState} from 'react';
import {AuthLayout} from "../../../core/layout/AuthLayout";
import BtnPrimary from "../../../shared/ui/button/primary/BtnPrimary";
import Table from "../../../shared/ui/table/table/Table";
import {TemplateTable} from "../../../shared/ui/table/models/TableProps";
import BtnDefault from "../../../shared/ui/button/default/BtnDefault";
import colorUtils from "../../../shared/colorUtils";
import {useSelector} from "react-redux";

import IconButton from "../../../shared/ui/icon/IconBtn";
import FormAddEmployee from "./components/FormAddEmployee";
import WarningMsg from "../../../shared/ui/warningMsg/WarningMsg";
import {useAppDispatch, useAppSelector} from "../../../app/hooks";
import {
    loadEmployeesAction,
    selectCanAddEmployee,
    selectCountPharmacistEmployees,
    selectPharmacistEmployeesLimit, selectSelectedPharmacist,
    selectUser
} from "../../../core/reducer/auth/authSlice";
import ModalRestoreEmployeeConfirm from "./components/ModalRestoreEmployeeConfirm";
import ModalDisabledEmployeeConfirm from "./components/ModalDisabledEmployeeConfirm";
import http from "../../../shared/utils/http";
import {selectEmployees} from "../../../core/reducer/pharmacySelector";
import {DisabledEmployees} from "./components/DisabledEmployees";
import {tableStructureEmployees} from "./EmployeeStructureData";
import LabelValue from "../../../shared/ui/labelValue/LabelValue";
import {addErrorMessage} from "../../../core/errors/errorSlice";


export function Employees() {
    const dispatch = useAppDispatch();
    const pharmacist = useSelector(selectSelectedPharmacist)

    const activeEmployees = useSelector(selectEmployees);
    const totEmployees = useSelector(selectPharmacistEmployeesLimit)
    const activeEmployeesCount = useSelector(selectCountPharmacistEmployees)
    const canAddEmployee = useSelector(selectCanAddEmployee)

    const [addEmployee, setAddEmployee] = useState<any | undefined>();
    const [restoreEmployeeModal, setRestoreEmployeeModal] = useState<any | undefined>();
    const [disableEmployeeModal, setDisabledEmployeeModal] = useState<any | undefined>();
    const [showEmployeeDisabled, setShowEmployeeDisabled] = useState<boolean>();

    const restoreEmployee = (data: any) => {
        setRestoreEmployeeModal(data)
    }
    const disableEmployee = (data: any) => {
        setDisabledEmployeeModal(data)
    }
    const templates: TemplateTable = {
        color: (value: any, row: any) => (
            <div style={{backgroundColor: value, width: '24px', height: '24px'}} title={value}></div>
        ),
        action: (value: any, row: any) => (
            <div className={'d-flex justify-content-end gap-2'}>
                {showEmployeeDisabled
                    ? <BtnDefault icon={'./assets/icons/restore.svg'} variant={'outline-primary'}
                                  tintColor={colorUtils.theme.primary} onClick={() => restoreEmployee(row)}
                                  disabled={!canAddEmployee}/>
                    : <>
                        <BtnDefault icon={'./assets/icons/edit.svg'} variant={'outline-primary'}
                                    tintColor={colorUtils.theme.primary} onClick={() => setAddEmployee(row)}/>
                        <BtnDefault icon={'./assets/icons/unavailable.svg'} variant={'outline-danger'}
                                    title={'Disabilita'}
                                    tintColor={colorUtils.theme.red} onClick={() => disableEmployee(row)}/>
                    </>
                }
            </div>
        )
    }


    const msgBlocked: any = {
        limitAddEmployee: `Limite dipendenti del piano raggiunto. Aggiorna il piano.`,
    };

    const confirmRestore = () => {
        http.get(`employees/${restoreEmployeeModal?.idDocument}/enabled`).then(res => {
            dispatch(loadEmployeesAction(() => {
                setShowEmployeeDisabled(false)
            }))
            closeRestoreEmployeeModal()
        }, err => {
        })
    }
    const confirmDisabled = () => {
        http.get(`employees/${disableEmployeeModal?.idDocument}/disabled`).then(res => {
            dispatch(loadEmployeesAction())
            closeDisabledEmployeeModal()
        }, err => {
        })
    }
    const closeRestoreEmployeeModal = () => {
        setRestoreEmployeeModal(undefined)
    }
    const closeDisabledEmployeeModal = () => {
        setDisabledEmployeeModal(undefined)
    }


    const updatePlan = () => {
        http.get(`pharmacists/${pharmacist}/linkupdate`).then(res => {
            window.open(res?.link?.url, '_self')
        }, err => {
            dispatch(addErrorMessage({title: 'Errore caricamento pagina per aggiornare il piano. Riprova più tardi, grazie.'}))
        })
    }

    return (
        <AuthLayout>
            <div className="row">
                <div className="col pt-3">
                    <div className={'d-flex justify-content-between align-items-center'}>
                        <div className={'d-flex align-items-center gap-3 flex-wrap row-gap-1'}>
                            <h3 className={'text-nowrap'}>Lista
                                Dipendenti {showEmployeeDisabled && 'Disabilitati'}
                            </h3>
                            <div className={'d-flex gap-3 mb-1'}>
                                <div className={'stats-employee'}>
                                    <LabelValue label={'In farmacia'} value={activeEmployees.length}
                                                inline={true}/>
                                </div>
                                <div className={'stats-employee'}>
                                    <LabelValue label={'Slot utilizzati'}
                                                value={`${activeEmployeesCount} / ${totEmployees}`}
                                                inline={true}/>
                                </div>

                            </div>
                            {!canAddEmployee && <WarningMsg msg={msgBlocked.limitAddEmployee}/>}
                        </div>
                        <div className={'d-flex gap-2'}>
                            <BtnPrimary variant={'outline-warning'} iconSize={'22px'}
                                        tintColor={colorUtils.theme.orange} icon={'./assets/icons/cart.svg'}
                                        className={'text-orange-500 text-nowrap'}
                                        onClick={updatePlan}>Aggiorna piano</BtnPrimary>
                            {!showEmployeeDisabled &&
                                <BtnPrimary icon={'./assets/icons/plus-c.svg'} onClick={() => setAddEmployee({})}
                                            className={'text-nowrap'}
                                            disabled={!canAddEmployee}>Aggiungi dipendente</BtnPrimary>
                            }
                            <BtnDefault variant={'outline-info'}
                                        tintColor={colorUtils.theme.info}
                                        className={'text-info text-nowrap'}
                                        onClick={() => setShowEmployeeDisabled(!showEmployeeDisabled)}>{showEmployeeDisabled ? 'Nascondi' : 'Mostra'} disabilitati</BtnDefault>
                        </div>
                    </div>

                    <div className="col list-container">
                        {
                            showEmployeeDisabled ?
                                <DisabledEmployees templates={templates}/> : <Table columns={tableStructureEmployees}
                                                                                    data={activeEmployees}
                                                                                    templates={templates}/>
                        }

                    </div>
                </div>
                {addEmployee && <div className="col py-3 shadow">
                    <div>
                        <div className={'d-flex justify-content-between align-items-center'}>
                            <h3>{`${addEmployee?.idDocument ? 'Modifica' : 'Nuovo'}`} dipendente</h3>
                            <IconButton icon={'./assets/icons/close.svg'} size={'18px'}
                                        clickHandler={() => setAddEmployee(undefined)}></IconButton>
                        </div>
                        <FormAddEmployee closeFormHandler={() => setAddEmployee(undefined)} dataEdit={addEmployee}/>
                    </div>
                </div>}

                {restoreEmployeeModal &&
                    <ModalRestoreEmployeeConfirm data={restoreEmployeeModal} confirmHandler={confirmRestore}
                                                 closeHandler={closeRestoreEmployeeModal}/>}
                {disableEmployeeModal &&
                    <ModalDisabledEmployeeConfirm data={disableEmployeeModal} confirmHandler={confirmDisabled}
                                                  closeHandler={closeDisabledEmployeeModal}/>}
            </div>
        </AuthLayout>
    );
}


